import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import AuthenticationStore from '../stores/AuthenticationStore';
import { baseUrl } from '../utils/Client';

import './Login.css';

import login from '../assets/login-bg.jpg';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: '',
      password: '',
      showPassword: false,
      message: null,
      loading: false,
    };
  }

  handleChange = event => {
    if (event.target.id === 'user') {
      this.setState({ user: event.target.value });
    } else if (event.target.id === 'password') {
      this.setState({ password: event.target.value });
    }
  };

  handleLogin = () => {
    console.log('handleLogin');
    this.setState({ message: null });
    var { user, password } = this.state;
    if (user && password) {
      AuthenticationStore.login(user, password)
        .then(() => this.props.history.goBack())
        .catch(e => {
          this.setState({ message: 'Usuário ou senha inválidos!' });
        });
    }
  };

  handleKeyDown = target => {
    if (target.charCode === 13) {
      this.handleLogin();
    }
  };

  togglePassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  render() {
    var { message, showPassword } = this.state;
    return (
      <Fragment>
        <div
          className={`bg-background lg:bg-[url('${login}')] bg-cover h-screen flex flex-col justify-center`}
        >
          <div className="h-screen lg:h-fit lg:rounded-2xl lg:m-12 absolute right-0 w-full lg:w-1/4 p-10 flex flex-col items-center bg-stone-50 border-stone-200 border-2 lg:shadow-lg">
            <img
              className="w-48 mt-4 lg:hidden"
              alt="Alvorada Pesquisas"
              src={baseUrl + '/img/logo.png'}
            />
            <div className="text-primary font-bold text-4xl mt-8">
              Bem-vindo!
            </div>
            <div className="text-gray-600 font-bold mt-8">
              Acesse sua conta para continuar
            </div>
            {message && (
              <div className="text-danger font-bold text-m mt-5">{message}</div>
            )}
            <form
              className="flex flex-col w-full mt-10"
              onSubmit={e => {
                e.preventDefault();
                this.handleLogin();
              }}
              onKeyDown={this.handleKeyDown}
            >
              <div className="group flex my-1 border-2 rounded-lg h-12 border-gray-300/75 focus-within:border-gray-300 bg-white">
                <div className="flex items-center justify-center shrink-0 w-12 fill-gray-600/75 group-focus-within:fill-gray-600/75">
                  <svg
                    width="19"
                    height="16"
                    viewBox="0 0 19 16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M17.1 0H1.9C0.855 0 0.00949999 0.890625 0.00949999 1.97917L0 13.8542C0 14.9427 0.855 15.8333 1.9 15.8333H17.1C18.145 15.8333 19 14.9427 19 13.8542V1.97917C19 0.890625 18.145 0 17.1 0ZM17.1 3.50867C17.1 3.78916 16.9582 4.05064 16.7232 4.20367L10.5912 8.19583C9.92783 8.62771 9.07217 8.62771 8.4088 8.19583L2.27684 4.20367C2.04178 4.05064 1.9 3.78916 1.9 3.50867C1.9 2.85038 2.63012 2.4545 3.18179 2.81367L8.4088 6.21666C9.07217 6.64854 9.92783 6.64855 10.5912 6.21666L15.8182 2.81367C16.3699 2.45451 17.1 2.85038 17.1 3.50867Z" />
                  </svg>
                </div>
                <input
                  type="text"
                  id="user"
                  name="user"
                  className="border-none focus:outline-0 w-full h-full px-3 bg-transparent text-gray-600/75 placeholder:text-gray-600/75 focus:text-gray-600 focus:placeholder:text-gray-600/75"
                  placeholder="E-mail"
                  autoComplete="username"
                  value={this.state.user}
                  onChange={this.handleChange}
                />
              </div>

              <div className="group flex my-1 border-2 rounded-lg h-12 border-gray-300/75 focus-within:border-gray-300 bg-white">
                <div className="flex items-center justify-center shrink-0 w-12 fill-gray-600/75 group-focus-within:fill-gray-600/75">
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 16 16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M 12.571429,5.3333333 H 11.809524 V 3.8095238 C 11.809524,1.7066667 10.102857,0 8.0000001,0 5.897143,0 4.1904763,1.7066667 4.1904763,3.8095238 V 5.3333333 H 3.4285715 c -0.8419047,0 -1.5238095,0.6819048 -1.5238095,1.5238096 V 14.47619 C 1.904762,15.318095 2.5866668,16 3.4285715,16 h 9.1428575 c 0.841904,0 1.523809,-0.681905 1.523809,-1.52381 V 6.8571429 c 0,-0.8419048 -0.681905,-1.5238096 -1.523809,-1.5238096 z M 8.0000001,12.190476 c -0.8419048,0 -1.5238095,-0.681905 -1.5238095,-1.523809 0,-0.8419051 0.6819047,-1.5238099 1.5238095,-1.5238099 0.8419048,0 1.5238095,0.6819048 1.5238095,1.5238099 0,0.841904 -0.6819047,1.523809 -1.5238095,1.523809 z M 10.361905,5.3333333 H 5.6380953 V 3.8095238 c 0,-1.3028571 1.0590477,-2.3619048 2.3619048,-2.3619048 1.3028571,0 2.3619049,1.0590477 2.3619049,2.3619048 z" />
                  </svg>
                </div>
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  className="border-none focus:outline-0 w-full h-full px-3 bg-transparent text-gray-600/75 placeholder:text-gray-600/75 focus:text-gray-600 focus:placeholder:text-gray-600/75"
                  placeholder="Senha"
                  autocomplete="current-password"
                  value={this.state.password}
                  onChange={this.handleChange}
                />
                <button
                  type="button"
                  className="flex items-center justify-center shrink-0 w-12 fill-gray-600/75 group-focus-within:fill-gray-600/75"
                  onClick={this.togglePassword}
                >
                  <svg
                    id="eye-slashed"
                    width="20"
                    height="20"
                    className={showPassword ? 'hidden' : 'block'}
                    viewBox="0 0 256 256"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M53.92,34.62A8,8,0,1,0,42.08,45.38L61.32,66.55C25,88.84,9.38,123.2,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208a127.11,127.11,0,0,0,52.07-10.83l22,24.21a8,8,0,1,0,11.84-10.76Zm47.33,75.84,41.67,45.85a32,32,0,0,1-41.67-45.85ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.16,133.16,0,0,1,25,128c4.69-8.79,19.66-33.39,47.35-49.38l18,19.75a48,48,0,0,0,63.66,70l14.73,16.2A112,112,0,0,1,128,192Zm6-95.43a8,8,0,0,1,3-15.72,48.16,48.16,0,0,1,38.77,42.64,8,8,0,0,1-7.22,8.71,6.39,6.39,0,0,1-.75,0,8,8,0,0,1-8-7.26A32.09,32.09,0,0,0,134,96.57Zm113.28,34.69c-.42.94-10.55,23.37-33.36,43.8a8,8,0,1,1-10.67-11.92A132.77,132.77,0,0,0,231.05,128a133.15,133.15,0,0,0-23.12-30.77C185.67,75.19,158.78,64,128,64a118.37,118.37,0,0,0-19.36,1.57A8,8,0,1,1,106,49.79,134,134,0,0,1,128,48c34.88,0,66.57,13.26,91.66,38.35,18.83,18.83,27.3,37.62,27.65,38.41A8,8,0,0,1,247.31,131.26Z" />
                  </svg>
                  <svg
                    id="eye"
                    width="20"
                    height="20"
                    className={showPassword ? 'block' : 'hidden'}
                    viewBox="0 0 256 256"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z" />
                  </svg>
                </button>
              </div>

              <button
                className="border-2 h-12 font-bold px-6 bg-primary rounded-lg text-white mt-5 uppercase"
                type="submit"
              >
                Entrar
              </button>

              <div className="text-primary grow font-medium flex flex-row justify-center items-center mt-8">
                <a href="/forgot-password" className="">
                  Esqueci minha senha
                </a>
              </div>
            </form>

            <div className="text-gray-600 grow font-medium flex items-end mt-12">
              © 2026 Mystra Tecnologia
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default observer(withRouter(Login));



// WEBPACK FOOTER //
// ./src/components/Login.js